import {Base, Shape} from 'diagram-js/lib/model';

export class NodeUtils {

  constructor(private moddle) {}

  /**
   *  The function creates new object from the given one
   *  with replacement of value in every property of this object to the new value
   */
  public createNewObjectWithReplacement(data, search: string, replacement:string) {
    if(data) {
      let str = JSON.stringify(data).replace(new RegExp(search, 'g'), replacement);
      return JSON.parse(str, this.createReviver());
    }
    return data;
  }

  // this function restores object that was converted to json string
  private createReviver(): Base {
    let elCache = {};

     return (key, object) => {

      if (typeof object === 'object' && (object!=null) && typeof object.$type === 'string') {

        let objectId = object.id;
        if (objectId && elCache[objectId]) {
          return elCache[objectId];
        }
        let type = object.$type;
        let attrs = Object.assign({}, object);
        delete attrs.$type;
        let newEl = this.moddle.create(type, attrs);
        if (objectId) {
          elCache[objectId] = newEl;
        }
        return newEl;
      }
      return object;
    };
  }
}
